import { takeLatest, put } from 'redux-saga/effects'
import {
  getUIConfigStart,
  getUIConfigSuccess,
  getUIConfigFailure,
  setGeneralConfig
} from 'store/redux-slices/ui-config'
import { getComponentConfig, getTenantConfig } from 'utils/apiCalls'

export default function * uiConfigWatcher () {
  yield takeLatest(getUIConfigStart.type, getUIConfigWorker)
}

function * getUIConfigWorker () {
  try {
    // Fetch tenant config first and expose it immediately
    const { data: tenantConfig } = yield getTenantConfig()
    if (tenantConfig) {
      yield put(setGeneralConfig(tenantConfig))
    }

    // Then fetch the dynamic components configuration
    const { data } = yield getComponentConfig()
    const configData = data?.data?.data || {}

    for (const page in configData) {
      configData?.[page]?.components?.sort((a, b) => a.priority - b.priority)
    }

    yield put(getUIConfigSuccess({ ...configData, general: tenantConfig }))
  } catch (e) {
    console.error('Error in components config', e)
    // Keep whatever general we might have set; just mark loading false
    yield put(getUIConfigFailure())
  }
}
